import React, { useState } from 'react';
import mainStyle from "./mainStyle.module.scss";

import { styled } from "@mui/material/styles";
import { Box, ClickAwayListener } from '@mui/material';
import { cloneDeep } from 'lodash';

import { SolidButton } from "components/buttons/SolidRectangleButton";

import { ReactComponent as BtnUpIcon } from "assets/images/icons/icn_button_up_light.svg";
import { ReactComponent as BtnDownIcon } from "assets/images/icons/icn_button_down_light.svg";
import icn_table_cell_authenticate from "assets/images/icons/icn_table_cell_authenticate.svg";
import icn_table_cell_authenticate_hover from "assets/images/icons/icn_table_cell_authenticate_hover.svg";
import icn_table_cell_settings from "assets/images/icons/icn_table_cell_settings.svg";
import icn_table_cell_settings_hover from "assets/images/icons/icn_table_cell_settings_hover.svg";
import icn_table_cell_adopt from "assets/images/icons/icn_table_cell_adopt.svg";
import icn_table_cell_adopt_hover from "assets/images/icons/icn_table_cell_adopt_hover.svg";

import BatchActionModal from './BatchActionModal';

import { BATCH_ACTION_LIST } from "./const"

const StyledDropdown = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "100%",
  left: 0,
  marginTop: theme.spacing(1),
  padding: "10px 20px",
  width: "251px",
  backgroundColor: theme.palette.primary.lightBlue,
  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
  borderRadius: 4,
  zIndex: 10,
  "&::before": {
    content: '""',
    position: "absolute",
    top: "-8px",
    left: "14px",
    width: 0,
    height: 0,
    borderLeft: "8px solid transparent",
    borderRight: "8px solid transparent",
    borderBottom: `8px solid ${theme.palette.primary.lightBlue}`,
  },
}));

const ActionItems = ({ actions, handleHover, handleDisplayModal, hover, scopeLevel }) => (
  <>
    {actions
      .filter(({ permissions }) => permissions.includes(scopeLevel))
      .map(({ key, label, icon, iconHover, modalKey }) => (
        <Box
          key={key}
          className={mainStyle["action_item"]}
          onMouseEnter={() => handleHover(key, true)}
          onMouseLeave={() => handleHover(key, false)}
          onClick={() => handleDisplayModal(modalKey, true)}
        >
          <img src={hover[key] ? iconHover : icon} alt={label} />
          <span>{label}</span>
        </Box>
      ))}
  </>
);

const ActionItemsInventory = ({ actions, handleHover, handleDisplayModal, hover }) => (
  <>
    {
      actions.map(({ key, label, icon, iconHover, modalKey }) => (
        <Box
          key={key}
          className={mainStyle["action_item"]}
          onMouseEnter={() => handleHover(key, true)}
          onMouseLeave={() => handleHover(key, false)}
          onClick={() => handleDisplayModal(modalKey, true)}
        >
          <img src={hover[key] ? iconHover : icon} alt={label} />
          <span>{label}</span>
        </Box>
      ))}
  </>
);

const ActionButton = ({
  handleDrawerClose,
  setOpenAddDeviceAction,
  openAction,
  setOpenAction,
  tabVal,
  currentTableInstance,
  auth,
  currentTableSelected,
  clickDiscover,
  clickSiteInventory,
  clickSiteUnityProxy,
  fetchTableData,
  itemCtrl,
  itemCallback,
  settingsData
}) => {
  const [hover, setHover] = useState({
    authenticate: false,
    setting: false,
    adopt: false,
    change: false,
    logout: false,
    bin: false
  })

  const [currentModal, setCrrentModal] = useState(null)
  const [displayModal, setDisplayModal] = useState({
    moveToSite: false,
    removeFromSite: false,
    deleteDevice: false,
  })

  function handleHover(key, isOpen) {
    setHover((prev) => ({ ...prev, [key]: isOpen }));
  };

  function handleDisplayModal(key, isOpen) {
    handleDrawerClose()
    setOpenAction(false);
    setDisplayModal((prev) => ({ ...prev, [key]: isOpen }));
    if (isOpen) {
      setCrrentModal(key)
    } else {
      setCrrentModal(null)
      currentTableInstance.setRowSelection({})
    }
  };

  if (clickDiscover) {
    return (
      <ClickAwayListener onClickAway={() => setOpenAction(false)}>
        <Box style={{ marginLeft: '5px', position: 'relative' }}>
          <SolidButton
            startIcon={openAction ? <BtnUpIcon /> : <BtnDownIcon />}
            width="100px"
            height="32px"
            onClick={() => {
              handleDrawerClose()
              setOpenAddDeviceAction(false)
              setOpenAction(!openAction)
            }}
          >
            Action
          </SolidButton>
          {openAction && (
            <StyledDropdown>
              <Box
                className={`${mainStyle["action_item"]} ${itemCtrl.discover.auth ? '' : mainStyle["action_item__disabled"]}`}
                onMouseEnter={() => handleHover('authenticate', true)}
                onMouseLeave={() => handleHover('authenticate', false)}
                onClick={() => {
                  if (itemCtrl.discover.auth) {
                    itemCallback.discover('auth');
                  }
                }}
              >
                <img src={hover.authenticate ? icn_table_cell_authenticate_hover : icn_table_cell_authenticate} alt="icn_table_cell_authenticate" />
                <span>Authenticate</span>
              </Box>
              <Box
                className={`${mainStyle["action_item"]} ${itemCtrl.discover.ipSetting ? '' : mainStyle["action_item__disabled"]}`}
                onMouseEnter={() => handleHover('setting', true)}
                onMouseLeave={() => handleHover('setting', false)}
                onClick={() => {
                  if (itemCtrl.discover.ipSetting) {
                    itemCallback.discover('ipSetting');
                  }
                }}
              >
                <img src={hover.setting ? icn_table_cell_settings_hover : icn_table_cell_settings} alt="icn_table_cell_settings" />
                <span>IP Settings</span>
              </Box>
              <Box
                className={`${mainStyle["action_item"]} ${itemCtrl.discover.adopt ? '' : mainStyle["action_item__disabled"]}`}
                onMouseEnter={() => handleHover('adopt', true)}
                onMouseLeave={() => handleHover('adopt', false)}
                onClick={() => {
                  if (itemCtrl.discover.adopt) {
                    itemCallback.discover('adopt');
                  }
                }}
              >
                <img src={hover.adopt ? icn_table_cell_adopt_hover : icn_table_cell_adopt} alt="icn_table_cell_adopt" />
                <span>Adopt</span>
              </Box>
            </StyledDropdown>
          )}
        </Box>
      </ClickAwayListener>
    )
  }

  /**
   * Batch Action List
   *
   * Org-level
   * - All, Access Points, Switches: Move to Site, Remove from Site, Delete Device
   * - Inventory: Move to Site, Delete Device
   * - Nuclias Unity Proxy: Delete Device
   *
   * Site-level
   * - All, Access Points, Switches: Remove from Site
   * - Inventory: Move to Site, Delete Device
   * - Nuclias Unity Proxy: Delete Device
   *
   **/
  const batchAction = cloneDeep(BATCH_ACTION_LIST);
  const isInventory = (tabVal && tabVal.indexOf('inventory') > -1) || clickSiteInventory;
  const isUnityProxy = (tabVal && tabVal.indexOf('proxy') > -1) || clickSiteUnityProxy;
  const isSiteNameNull = !(tabVal && tabVal.indexOf('proxy') > -1 || (tabVal && tabVal.indexOf('proxy') > -1))
    && currentTableSelected[0].original.siteName === null
  const isDevicesypeProxy = !(tabVal && tabVal.indexOf('proxy') > -1 || (tabVal && tabVal.indexOf('proxy') > -1))
    && currentTableSelected[0].original.deviceType === 'proxy'

  if (isSiteNameNull) {
    delete batchAction[1];
    if (isDevicesypeProxy) delete batchAction[0];
  }

  if (isInventory) {
    delete batchAction[1];
  }

  if (isUnityProxy) {
    delete batchAction[0];
    delete batchAction[1];
    batchAction[2].permissions = ['org', 'site'];
  }

  return (
    <>
      <Box style={{ marginLeft: '5px', position: 'relative' }}>
        <SolidButton
          startIcon={openAction ? <BtnUpIcon /> : <BtnDownIcon />}
          width="100px"
          height="32px"
          onClick={() => {
            handleDrawerClose()
            setOpenAddDeviceAction(false)
            setOpenAction(!openAction)
          }}
        >
          Action
        </SolidButton>
        {openAction && tabVal !== 'add_device' && (
          <StyledDropdown id="child">
            {
              isInventory ? (
                <ActionItemsInventory
                  actions={batchAction}
                  handleHover={handleHover}
                  handleDisplayModal={handleDisplayModal}
                  hover={hover}
                />
              ) : (
                <ActionItems
                  isInventory={isInventory}
                  actions={batchAction}
                  handleHover={handleHover}
                  handleDisplayModal={handleDisplayModal}
                  hover={hover}
                  scopeLevel={auth.scopeLevel}
                />
              )}
          </StyledDropdown>
        )}
      </Box>
      <BatchActionModal
        tabVal={tabVal}
        currentModal={currentModal}
        display={displayModal[currentModal]}
        handleCloseModal={() => handleDisplayModal(currentModal, false)}
        auth={auth}
        currentTableSelected={currentTableSelected}
        clickSiteInventory={clickSiteInventory}
        fetchTableData={fetchTableData}
        settingsData={settingsData}
      />
    </>
  );
}

export default ActionButton;